import { cloneDeep } from 'lodash';
import { ModelType } from '@/enums/model-type.enum';
import type { Node } from '@/types/node';
import type { AiModelData } from '@/types/nodes/model';

/** Maps an AI model service to the icon key used in template/node-definition entries. */
export function getModelServiceIconKey(service: string): string {
  switch (service) {
    case ModelType.FalImported:
      return 'fal';
    case ModelType.Replicate:
      return 'replicate';
    case ModelType.Civit:
      return 'civit';
    default:
      return 'weavy';
  }
}

// TODO: Check if imported → user_defined conversion is still needed with subflow templates.
// Legacy behavior from the old /v1/user/node-definitions save path.
export function prepareModelNode(node: Node): Node {
  const clone = cloneDeep(node);
  const data = clone.data as AiModelData;
  if (data.kind?.type === 'wildcard' && data.kind.model.type === 'imported') {
    data.kind = {
      ...data.kind,
      model: { ...data.kind.model, type: 'user_defined' },
    };
  }
  return clone;
}
